import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkinWouldBetterPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionSkinWouldBetter.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionSkinWouldBetter.button1'),
          value: 'knew_products',
        },
        {
          text: t('pages.onboarding.questionSkinWouldBetter.button2'),
          value: 'consistent_routine',
        },
        {
          text: t('pages.onboarding.questionSkinWouldBetter.button3'),
          value: 'understood_needs',
        },
        {
          text: t('pages.onboarding.questionSkinWouldBetter.button4'),
          value: 'manage_stress',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
